import styled from 'styled-components';

import { RounderContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import { hex2rgb } from '@r1-frontend/shared/helpers/hex2rgb';

export const Content = styled.div`
    align-items: center;
    ${FONTS.LABEL_S};
    color: rgba(${hex2rgb(COLORS.TextWhite)}, .8);
`;

export const LabelContainer = styled(RounderContainer)`
    background: rgba(${hex2rgb(COLORS.GRAY_LIGHT)}, .3);
    cursor: pointer;
    height: fit-content;
    width: min-content;
`;
